import { render, staticRenderFns } from "./PricingIndex.vue?vue&type=template&id=7a33824d&"
import script from "./PricingIndex.vue?vue&type=script&lang=js&"
export * from "./PricingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports